<template>
  <router-view />
</template>
<script>
  export default {
    name: 'players'
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/players/index.vue